import { render } from "./FlashMessage.vue?vue&type=template&id=4704bcd6&scoped=true"
import script from "./FlashMessage.vue?vue&type=script&lang=js"
export * from "./FlashMessage.vue?vue&type=script&lang=js"

import "./FlashMessage.vue?vue&type=style&index=0&id=4704bcd6&scoped=true&lang=css"

import exportComponent from "/var/www/autis/releases/43/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4704bcd6"]])

export default __exports__